<template>
  <div class="announcement-card" :class="{ 'has-actions': removable || editable || showActive || showVerify }">
    <div class="card-actions" v-if="removable || editable || showActive || showVerify">
      <button class="btn-icon btn-danger" v-if="removable" @click="$emit('deleteAnnouncement', id)" title="Usuń">
        <img src="@/assets/icons/trash.svg" alt="usuń">
      </button>

      <button
          class="btn-icon"
          v-if="editable"
          @click="$emit('showEditModal', { titleValue: title, contentValue: longContent, shortDescriptionValue: content, id: id, target: target, contact: contact, category: category })"
          title="Edytuj"
      >
        <img src="@/assets/icons/pencil-square.svg" alt="edytuj">
      </button>

      <span class="status-chip" v-if="showActive">
        <img src="@/assets/icons/eye-fill.svg" alt="aktywne" v-if="active">
        <img src="@/assets/icons/eye-slash-fill.svg" alt="nieaktywne" v-if="!active">
        {{ active ? 'Aktywne' : 'Nieaktywne' }}
      </span>

      <button class="btn-icon btn-success" v-if="showVerify && !active" @click="$emit('verifyAnnouncement', { id: id })" title="Weryfikuj">
        <img src="@/assets/icons/check.svg" alt="weryfikuj">
      </button>
    </div>

    <div class="card-image-wrap">
      <img :src="img" alt="">
    </div>

    <div class="card-body">
      <div class="card-tags">
        <span class="tag">{{ target }}</span>
        <span class="tag">{{ category }}</span>
      </div>

      <h3 class="card-title">{{ title }}</h3>
      <p class="card-short">{{ content }}</p>

      <div class="card-footer">
        <button class="card-cta" type="button" @click="checkUser()">
          {{ isContentVisible ? 'Pokaż mniej' : 'Czytaj więcej' }}
        </button>
      </div>

      <div v-if="isContentVisible" class="card-long">
        <p>{{ longContent }}</p>

        <div class="long-actions">
          <span class="action-link" role="button" @click="() => showContact = !showContact">
            {{ showContact ? contact : 'Pokaż adres e-mail' }}
          </span>

          <span
              class="action-link"
              v-if="reportable && currentUser && (currentUser.role_id === 3 || currentUser.role_id === 2)"
              role="button"
              @click="report()"
          >
            Zgłoś
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useAuthStore } from '@/stores/auth';

export default {
  name: 'AnnouncementCardVue',
  setup() {
    return {
      authStore: useAuthStore(),
    };
  },
  data() {
    return {
      isContentVisible: false,
      showContact: false,
    };
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    },
  },
  methods: {
    report() {
      const route = this.$router.resolve({ path: '/report', query: { label: `ogłoszenie: ${this.title}`, id: this.id, property: 'announcement_id' } });
      window.open(route.href, '_blank');
    },
    checkUser() {
      if (this.currentUser) {
        this.isContentVisible = !this.isContentVisible;
      } else {
        this.$router.push('/login');
      }
    },
  },
  props: {
    img: {},
    title: {},
    content: {},
    removable: {},
    reportable: {
      type: Boolean,
      default: true,
    },
    id: {},
    editable: {},
    longContent: {},
    contact: {},
    target: {},
    category: {},
    active: {},
    showActive: {},
    showVerify: {},
  }
};
</script>

<style scoped lang="scss">
.announcement-card {
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-radius: 12px;
  background-color: #fff;
  border: 1px solid #f3f4f6;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .05);
  min-height: 430px;
  position: relative;
  transition: box-shadow .2s ease, transform .2s ease;
}

.announcement-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 16px 28px rgba(0, 0, 0, .12);
}

.card-actions {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 2;
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.card-image-wrap {
  width: 100%;
}

.card-image-wrap img {
  width: 100%;
  height: 190px;
  object-fit: cover;
  display: block;
}

.card-body {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 14px;
  height: 100%;
  min-width: 0;
}

.card-tags {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

.tag {
  display: inline-block;
  width: fit-content;
  font-size: 1.2rem;
  color: #6b7280;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  padding: 4px 8px;
  border-radius: 999px;
  font-weight: 700;
}

.card-title {
  text-align: left;
  font-size: 2rem;
  color: #111827;
  line-height: 1.3;
  margin: 0;
}

.card-short {
  margin: 0;
  color: #4b5563;
  font-size: 1.4rem;
  line-height: 1.5;
  flex-grow: 1;
}

.card-footer {
  margin-top: auto;
  padding-top: 12px;
  border-top: 1px solid #e5e7eb;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 10px;
}

.card-cta {
  border: none;
  background: transparent;
  color: #10b981;
  font-size: 1.4rem;
  font-weight: 700;
  cursor: pointer;
  padding: 0;
  transition: color .2s ease;
}

.card-cta:hover {
  color: #059669;
  text-decoration: underline;
}

.card-long {
  border-top: 1px solid #e5e7eb;
  padding-top: 12px;
}

.card-long p {
  margin: 0;
  color: #4b5563;
  font-size: 1.4rem;
  line-height: 1.5;
}

.long-actions {
  margin-top: 12px;
  display: flex;
  gap: 14px;
  flex-wrap: wrap;
}

.action-link {
  cursor: pointer;
  font-weight: 700;
  color: #10b981;
  font-size: 1.35rem;
}

.action-link:hover {
  color: #059669;
  text-decoration: underline;
}

.status-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  background-color: #f3f4f6;
  border: 1px solid #e5e7eb;
  color: #374151;
  border-radius: 999px;
  padding: 6px 10px;
  font-size: 1.2rem;
  font-weight: 700;
}

.status-chip img {
  width: 16px;
  height: 16px;
}

.btn-icon {
  background: #fff;
  border: 1px solid #e5e7eb;
  cursor: pointer;
  padding: 6px;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  transition: background-color 0.2s, border-color 0.2s;
}

.btn-icon:hover {
  background-color: #f3f4f6;
  border-color: #d1d5db;
}

.btn-icon img {
  width: 18px;
  height: 18px;
}

.btn-danger:hover {
  background-color: #fee2e2;
}

.btn-success:hover {
  background-color: #dcfce7;
}
</style>